import { render, staticRenderFns } from "./bulkApproval.vue?vue&type=template&id=5bc0638e"
import script from "./bulkApproval.vue?vue&type=script&lang=js"
export * from "./bulkApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports